'use strict';

import 'angular';

import modalDirective from '../rest-modal';

import template from './template.html';

export default modalDirective({
	template: template,
	resolve: {
		designatedUsers: resolveDesignatedUsers,
	}
});


function resolveDesignatedUsers($http, $context) {
	'ngInject';
	if ($context.designations && !angular.equals($context.designations, {})) {
		return $http.get('/designated-user/').then(function(response) {
			var designatedUsers = {};
			for (var du of response.data) {
				designatedUsers[du.designation] = du;
			}
			var retval = {};
			for (var version in $context.designations) {
				if ($context.designations.hasOwnProperty(version)) {
					retval[version] = $context.designations[version].sources.map(d => {
						var du = angular.copy(designatedUsers[d]);
						if (du) {
							du.target = $context.designations[version].target 
							return du;
						} else {
							return null;
						}
					}).filter(du => du !== null);
				}
			}
			return retval;
		});
	}
}
